import React from 'react';
import { Chip } from '@mui/material';

const CustomChip = ({ label, ...props }) => {
  return (
    <Chip
      style={{ borderRadius: '4px' }}
      label={label}
      {...props}
    />
  );
};

export default CustomChip;
